import ObtainAdvisorError from './ObtainAdvisorError';
class MeetingNotFound extends ObtainAdvisorError {
    constructor() {
        super('Advisor meeting not found');
    }
}
export default MeetingNotFound;
